<template>
  <div class="table" style="padding:10px">
   <a-row justify="space-between" align="middle"  style="margin-bottom:10px;position:relative;">
      <a-tabs v-model="activeKey">
        <a-tab-pane :key="1" tab="合计">
          <tabs-list ref='totalList' :rawsType="rawsType" :columns="columns" :tableX="tableX" :hasProductVersion='hasProductVersion' @refresh="refresh"/>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="补充料">
          <tabs-list2 ref="blendList" :rawsType="rawsType" :columns="columns" :tableX="tableX" :hasProductVersion='hasProductVersion' @refresh="refresh"/>
        </a-tab-pane>
      </a-tabs>
      <a-space style="position:absolute;right: 0;top: 10px;">
        <!-- <slot /> -->
        <!-- <a-button type='primary' @click="() => toggleVisible('nutChoose')" size="small" style="margin-right: 10px;">养分选择表</a-button> 
        <a-select v-model="rawsType" style="width: 120px" @change="rawsChange">
          <a-select-option value="all">显示所有指标</a-select-option>
          <a-select-option value="1">仅展示有值的指标</a-select-option>
          <a-select-option value="2">仅展示有约束的指标</a-select-option>
        </a-select>
        <a-select v-model="columnsArr" class="multipleStyle" style="width: 200px;" mode="multiple" placeholder="请选择表头">
          <a-select-option v-for="el in columnsOptions" :key="el.dataIndex" :value="el.dataIndex">{{el.title}}</a-select-option>
        </a-select> -->
        <a-tooltip>
            <template slot="title">
              养分选择表
            </template>
          <a-icon type="branches"  @click="() => toggleVisible('nutChoose')" style="font-size: 16px;color: #1890ff;"/>
        </a-tooltip>
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="control" style="font-size: 16px;"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a :style="{color: rawsType === 'all'?'#1890ff':''}" @click="() => rawsChange('all')">显示所有指标</a>
            </a-menu-item>
            <a-menu-item>
              <a :style="{color: rawsType === '1'?'#1890ff':''}" @click="() => rawsChange('1')">仅展示有值的指标</a>
            </a-menu-item>
            <a-menu-item>
              <a :style="{color: rawsType === '2'?'#1890ff':''}" @click="() => rawsChange('2')">仅展示有约束的指标</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown v-show="activeKey === 1">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="filter" style="font-size: 16px;"/>
          </a>
          <a-menu slot="overlay">
            <a-checkbox-group class="ell-label" :defaultValue="nutritionEditor" @change="changeCol" style="background: #fff;padding: 8px;">
              <div v-for='allItem in NutritionTotals' :key="allItem.dataIndex" style="padding-bottom: 5px;">
                <a-checkbox :value="allItem.dataIndex">{{allItem.title}}</a-checkbox>
              </div>
            </a-checkbox-group>
            
          </a-menu>
        </a-dropdown>
        <a-dropdown v-show="activeKey === 2">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="filter" style="font-size: 16px;"/>
          </a>
          <a-menu slot="overlay">
            <a-checkbox-group class="ell-label" :defaultValue="nutritions" @change="changeCol" style="background: #fff;padding: 8px;">
              <div v-for='allItem in NutritionCols' :key="allItem.dataIndex" style="padding-bottom: 5px;">
                <a-checkbox :value="allItem.dataIndex">{{allItem.title}}</a-checkbox>
              </div>
            </a-checkbox-group>
          </a-menu>
        </a-dropdown>
        
          
      </a-space>
    </a-row>
    <nutrition-modal :linkId="detail.linkId"  @ok="addNutrition" @cancel="toggleVisible('nutChoose')" :hidden="visible.nutChoose" @view="setDetail" />
    <nutrition-detail-modal :item="selectItem" :hidden="detailVisible" @cancel="toggleDetailVisible" />
    <compound-create-modal />
    <!-- <nutrition-raw-need-modal />
    <nutrition-raw-need-modal2 /> -->
  </div>
</template>
<script>
import {nhfMixins} from '../../untils'
import NutritionDetailModal from '../modal/NutritionDetailModal.vue'
import NutritionModal from '../modal/NutritionModal.vue'
// import NutritionRawNeedModal from '../modal/NutritionRawNeedModal.vue'
// import NutritionRawNeedModal2 from '../modal/NutritionRawNeedModal2.vue'
import CompoundCreateModal from '../modal/CompoundCreateModal.vue'
// import CellEditor from './CellEditor.vue'
import TabsList from './TabsList.vue'
import TabsList2 from './TabsList2.vue'
import NutritionColumns from './NutritionColumns'
import Nutritions from './Nutrition'
// import NutritionColumns
export default {
  props:['hasProductVersion'],
  components: { NutritionModal, NutritionDetailModal
  // , NutritionRawNeedModal,NutritionRawNeedModal2
  ,CompoundCreateModal,TabsList,TabsList2},
  mixins:[nhfMixins],
  data(){
    return{
      NutritionTotals:NutritionColumns.filter(el => el.dataIndex !== 'nutritionName'),
      NutritionCols:Nutritions.filter(el => el.dataIndex !== 'nutritionName'),
      arr: [],
      activeKey: 1,
      nutritonListLoading:false,
      priceSource:null,
      chooseVisible:false,
      list:{
        records:[]
      },
      // 指标名称、指标全称、数值、单位、最小值、最大值、单位成本、适用下限、适用上限、极下限、极上限
      detailVisible:false,
      selectItem:{},
      rawsType: 'all',
      columnsArr: ['unit','content','minValue','maxValue','cost','minApply','maxApply'
      // ,'minLimitValue','maxLimitValue'
      ],
      columnsOptions: [
      {
        dataIndex:'unit',
        title:'单位',
        width: 60,
      },
      {
        dataIndex:'content',
        scopedSlots: { customRender: 'content' },
        title:'数值',
        sorter: (a, b) => a.content - b.content,
        sortDirections: ['descend', 'ascend'],
        align:'center',
        width: 100,
      },
      {
        dataIndex:'productContent',
        align:'center',
        title: '产品',
        scopedSlots: {customRender: 'productContent'},
        sorter: (a, b) => a.productContent - b.productContent,
        sortDirections: ['descend', 'ascend'],
        width:100
      },
      {
        dataIndex:'minValue',
        scopedSlots: {customRender: 'minValue'},
        title: '最小值',
        sorter: (a, b) => a.minValue - b.minValue,
        sortDirections: ['descend', 'ascend'],
        align:'center',
        width:100,
      },
      {
        dataIndex:'maxValue',
        scopedSlots: {customRender: 'maxValue'},
        align:'center',
        title: '最大值',
        sorter: (a, b) => a.maxValue - b.maxValue,
        sortDirections: ['descend', 'ascend'],
        width:100,
      },
      {
        dataIndex:'cost',
        title:'单位成本',
        sorter: (a, b) => a.cost - b.cost,
        align:'center',
        scopedSlots: {customRender: 'cost'},
        sortDirections: ['descend', 'ascend'],
        width: 100,
      },
      {
        dataIndex:'minApply',
        title:'适用下限',
        align:'center',
        sorter: (a, b) => a.minApply - b.minApply,
        scopedSlots: {customRender: 'minApply'},
        sortDirections: ['descend', 'ascend'],
        width: 100,
      },
      {
        dataIndex:'maxApply',
        title:'适用上限',
        align:'center',
        sorter: (a, b) => a.maxApply - b.maxApply,
        scopedSlots: {customRender: 'maxApply'},
        sortDirections: ['descend', 'ascend'],
        width:  100,
      },
      {
        dataIndex:'minLimitValue',
        scopedSlots: {customRender: 'minLimitValue'},
        align:'center',
        title: '极下限',
        sorter: (a, b) => a.minLimitValue - b.minLimitValue,
        sortDirections: ['descend', 'ascend'],
        width:  100,
      },
      {
        dataIndex:'maxLimitValue',
        scopedSlots: {customRender: 'maxLimitValue'},
        align:'center',
        title:'极上限',
        sorter: (a, b) => a.maxLimitValue - b.maxLimitValue,
        sortDirections: ['descend', 'ascend'],
        width:  100,
      },
      ],
      dropdownVisible: false,
      dropdownVisible2: false
    }
  },
  
  mounted(){
    const {id} = this.$route.query
    this.formulaId = id
    
    let list = window.localStorage.getItem('NutritionEditor')
    if(list && list !== 'null'){
      this.columnsArr = JSON.parse(list)
    }
    
    let rawsType = window.localStorage.getItem('rawsType3')
    if(rawsType){
      this.rawsType = rawsType
      this.rawsChange(rawsType)
    }
  },
  watch:{
    // nutritionEditor: {
    //   handler(val){
    //     console.log('nutritionEditor',val)
    //   },
    //   deep: true
    // },
    // nutritions: {
    //   handler(val){
    //     console.log('nutritions',val)
    //   },
    //   deep: true
    // },
    // columnsArr:{
    //   handler(val){
    //     window.localStorage.setItem('NutritionEditor',JSON.stringify(val))
    //     this.setState({nutritionEditor:val})
    //   },
    //   deep: true
    // },
    activeKey(){
      this.$emit('changeTab')
    },
    selectedRows(nutRows){
      this.$emit('select',nutRows,1)
      this.setState({nutSelect:nutRows[0],nutRows})
    },
  },
  computed:{
    tableX(){
      let num = 0
      this.columns.forEach(el => {
        num += el.width
      })
      return Math.max(this.rightWidth - 30,num)
    },
    columns(){
      let options = this.columnsOptions.filter(el => this.columnsArr.includes(el.dataIndex))
      let first = {
        dataIndex:'nutritionName',
        scopedSlots: { customRender: 'nutritionName' },
        title:'指标名称',
        fixed: this.rightWidth - 30 < this.tableNum ? 'left' : '',
        width: 150,
      }
      let lst = [first,...options]
      return lst
    },
    listData(){
      return {
        rawIds:this.selectedRowKeys.join(),
        formulaId:this.formulaId
      }
    }
  },

  methods:{
    changeCol(val){
      if(this.activeKey === 1){
        window.localStorage.setItem('NutritionEditor',JSON.stringify(val))
        this.setState({nutritionEditor:val})
      }else{
        window.localStorage.setItem('Nutrition',JSON.stringify(val))
        this.setState({nutritions:val})
      }
    },
    init(){
      // this.rawsType = 'all'
      this.$refs.totalList && this.$refs.totalList.getList()
      this.$refs.blendList && this.$refs.blendList.getList()
    },
    changeItems(val){
      console.log(val)
    },
    getCloumns(dataIndex){
      if(this.columnsArr.includes(dataIndex)){
        this.columnsArr = this.columnsArr.filter(el => el !== dataIndex)
      }else{
        this.columnsArr.push(dataIndex)
      }
    },
    rawsChange(val){
      // let newData = JSON.parse(JSON.stringify(this.cacheData))
      // if(this.rawsType === 'all'){
      //   this.list.records = newData
      // }else if(this.rawsType === '1'){
      //   this.list.records = newData.filter(v => v.uasge && v.uasge > 0)
      // }else if(this.rawsType === '2'){
      //   this.list.records = newData.filter(v => !v.uasge)
      // }
      this.rawsType = val
      window.localStorage.setItem('rawsType3',this.rawsType)
      setTimeout(() => {
        this.$refs.totalList && this.$refs.totalList.changeRaw()
        this.$refs.blendList && this.$refs.blendList.changeRaw()
      }, 0);
    },
    len(record){ 
      return record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2
    },
    viewNut(nutSelect){
      this.setState({nutSelect})
      this.toggleVisible('nut')
    },
    toggleDetailVisible(){
      this.detailVisible = !this.detailVisible
    },
    cleanSelect(){
      this.selectedRowKeys=[]
      this.selectedRows=[]
    },
    setDetail(item){
      this.selectItem = item
      this.toggleDetailVisible()
      this.toggleVisible('nutChoose')
    },
    itemChange(value, id, column) {
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      if (target) {
        target[column] = value
        this.list.records = newData
      }
    },
    eidtorItem(id){
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list.records = newData
      }
    },
    saveHandle(key){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.id)[0]
      const targetCache = newCacheData.filter(item => key === item.id)[0]
      if (target && targetCache) {
        delete target.editable
        this.list.records = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
        this.update(target)
      }
    },
    itemUpdate(item,id){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const targets = newData.filter(item => id === item.id)[0]
      const targetCache = newCacheData.filter(item => id === item.id)[0]
      if (targets && targetCache) {
        this.list.records = newData
        Object.assign(targetCache, item)
        Object.assign(targets, item)
        this.cacheData = newCacheData
        this.list.records = newData
      }
    },

    async update(arg){
      // this.nutritonListLoading = true
      let data = JSON.parse(JSON.stringify(arg))
      delete data.nutritionFullName
      await this.fetchPost({
        actions:this.formulanutritionUpdate,
        data,
        showMessage:false
      })
      this.$emit('refresh',false,false)
    },
    refresh(){
      this.$emit('refresh',false,false)
    },

    cancelHandle(id){
      let newData = [...this.list.records]
      let target = newData.filter(item => id === item.id)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
        target.editable = false
        this.list.records = newData
      }
    },

    restetList(){
      this.$confirm({
        title: '提示',
        content: '确认将选中的营养指标恢复至默认值吗？',
        okText: '继续',
        cancelText: '取消',
        onOk: async () =>{
          this.resetNutrition()
        },
        onCancel(){},
      })
    },

    async resetNutrition(){
      this.fetchPost({
        actions:this.resetFormulaNutritionIds,
        data:{
          formulaId:this.formulaId,
          ids:this.selectedRows.map(i=>i.id).join()
        }
      })
      // this.getList()
    },

    async addNutrition(row){
      this.nutritonListLoading = true
      this.toggleVisible('nutChoose')
      await this.fetchPost({
        actions:this.saveFormulaMixNutritionId,
        data:{
          formulaId:this.formulaId,
          ids:row.map(i=>i.id).join()
        }
      })
      this.$emit('res')
      // this.getList()
      if(this && this.$refs){
        this.$refs.totalList && this.$refs.totalList.getList()
        this.$refs.blendList && this.$refs.blendList.getList()
      }
    },

    getList(arg = {},sorter){
      this.$nextTick(async ()=>{
        if(!this.formulaId) return
         let res = await this.fetchGet({
          isList:true,
          loading:'nutritonListLoading',
          actions:this.formulaNutritionNhfPage,
          name:'list',
          sorter,
          data:{
            formulaId:this.formulaId,
            ...arg,
            size:1000
          }
        })
        this.cleanSelect()
        let {data} = res || {}
        let {records} = data || {}
        this.cacheData = JSON.parse(JSON.stringify(records || []))
      })
    },
    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
  }
}
</script>

<style lang="scss" scoped>
  h3{
    margin: 0;
  }
  .red{color: red;}
  .green{color: green;}
</style>
